import { render, staticRenderFns } from "./titleYear.vue?vue&type=template&id=8c45accc&scoped=true"
import script from "./titleYear.vue?vue&type=script&lang=js"
export * from "./titleYear.vue?vue&type=script&lang=js"
import style0 from "./titleYear.vue?vue&type=style&index=0&id=8c45accc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c45accc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c45accc')) {
      api.createRecord('8c45accc', component.options)
    } else {
      api.reload('8c45accc', component.options)
    }
    module.hot.accept("./titleYear.vue?vue&type=template&id=8c45accc&scoped=true", function () {
      api.rerender('8c45accc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/dialog/titleYear.vue"
export default component.exports